import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatModule } from '../../mat/mat.module';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogData } from '../../models/confirmationDialogData.model';

@Component({
    selector: 'urban-confirmation-dialog',
    host: { class: 'uvDialogAlert' },
    imports: [MatModule, TranslateModule],
    templateUrl: './confirmation-dialog.component.html'
})

export class ConfirmationDialogComponent {
  public title: string = this.data?.title ?? 'CONFIRMATION.CONFIRM';
  public description: string = this.data?.description ?? 'CONFIRMATION.CONTINUE';
  public descriptionParams: Record<string, string> | undefined = this.data?.descriptionParams;
  public confirmBtnLabel: string = this.data?.confirmBtnLabel ?? 'CONFIRMATION.YES';
  public cancelBtnLabel: string = this.data?.cancelBtnLabel ?? 'CONFIRMATION.NO';
  public isDeleteAction: boolean = this.data?.isDeleteAction ?? false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {}
}
